import api from "@/lib/api";

const cache = new Map();

/** Who on 13thav sells this room's work? Asked once per visit, then remembered. */
export const sellersOf = (room) => {
    if (!cache.has(room)) {
        cache.set(room, api.get(`/stores/sellers?room=${room}`)
            .then(({ data }) => data.stores || [])
            .catch(() => { cache.delete(room); return []; }));
    }
    return cache.get(room);
};
